// src/shared/hooks/useAuth.js
import { useContext, useCallback } from 'react';
import { AuthContext } from '../../contexts/AuthContext';

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }

    const hasPermission = useCallback(
        (permission) => {
            const perms = context.user?.permissions;
            if (!Array.isArray(perms)) return false;
            if (perms.includes(permission)) return true;
            // users:managePermissions implicitly grants users:viewPermissions
            if (permission === 'users:viewPermissions' && perms.includes('users:managePermissions')) return true;
            return false;
        },
        [context.user]
    );

    return { ...context, hasPermission };
};
